
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/multiple-Portal.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-multiple-portal-demo-multiple-portal"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/jilin/projects/antd/rc-dialog/docs/demo/multiple-Portal.md?type=demo')
};